/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GeoJsonInformativeProperties } from "models/informatives.model";
import { GetInformativesGeojsonState } from "store/modules/posts/types";

const initialState: GetInformativesGeojsonState = {
    isRequesting: false,
    successPayload: null,
    errors: []
};

const getInformativesGeojsonSlice = createSlice({
    name: "posts@getInformativesGeojson",
    initialState,
    reducers: {
        getInformativesGeojsonRequest: (
            state            
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        getInformativesGeojsonSuccess: (
            state,
            action: PayloadAction<GeoJSON.FeatureCollection<GeoJSON.Point, GeoJsonInformativeProperties>>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        getInformativesGeojsonFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    getInformativesGeojsonFailed,
    getInformativesGeojsonRequest,
    getInformativesGeojsonSuccess
} = getInformativesGeojsonSlice.actions;
export default getInformativesGeojsonSlice.reducer;
